import BrandLogo from '../BrandLogo.jsx';
import { clsx } from '../../utils/cn.js';

const SIZES = {
  sm: { ring: 'h-16 w-16', logo: 'max-h-10' },
  md: { ring: 'h-28 w-28', logo: 'max-h-16' },
  lg: { ring: 'h-36 w-36', logo: 'max-h-24' },
};

/**
 * Pantalla o bloque de carga con el logo de Coonaltragas.
 * @param {'fullscreen' | 'section' | 'inline'} variant
 * @param {'dark' | 'light'} tone — fondo oscuro (hero/admin) o claro (listados)
 */
export default function BrandLoading({
  variant = 'section',
  size = 'md',
  label = 'Cargando…',
  tone = 'dark',
  className,
}) {
  const s = SIZES[size] ?? SIZES.md;
  const isLight = tone === 'light';

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label || 'Cargando'}
      className={clsx(
        'flex flex-col items-center justify-center gap-6',
        variant === 'fullscreen' && 'fixed inset-0 z-50 min-h-screen bg-brand-navy',
        variant === 'section' && 'relative min-h-[68vh] w-full overflow-hidden bg-brand-navy',
        variant === 'inline' && 'w-full py-16',
        className
      )}
    >
      {variant === 'section' && (
        <>
          <div
            className="pointer-events-none absolute inset-0 bg-gradient-to-br from-brand-navy via-brand-green-dark/40 to-brand-navy"
            aria-hidden
          />
          <div
            className="pointer-events-none absolute left-1/2 top-1/3 h-64 w-64 -translate-x-1/2 rounded-full bg-[#1acb12]/15 blur-3xl"
            aria-hidden
          />
        </>
      )}

      <div className={clsx('relative z-10 flex flex-col items-center gap-5', variant === 'inline' && 'z-auto')}>
        <div className={clsx('relative flex items-center justify-center', s.ring)}>
          <div
            className={clsx(
              'absolute inset-0 animate-spin rounded-full border-2 border-t-brand-green border-r-[#1acb12]',
              isLight ? 'border-slate-200' : 'border-white/15'
            )}
            aria-hidden
          />
          <div
            className={clsx(
              'absolute inset-3 rounded-full animate-pulse motion-reduce:animate-none',
              isLight ? 'bg-brand-green/15' : 'bg-brand-green/10'
            )}
            aria-hidden
          />
          <BrandLogo eager className={clsx('relative z-10 animate-logo-breathe', s.logo)} alt="" />
        </div>
        {label ? (
          <p
            className={clsx(
              'text-sm font-medium uppercase tracking-[0.22em]',
              isLight ? 'text-slate-500' : 'text-white/65'
            )}
          >
            {label}
          </p>
        ) : null}
      </div>
    </div>
  );
}
